<!-- svelte-ignore a11y-missing-attribute -->

<Secure>
  <section class="section hero">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-two-fifths">
            <div class="card">
              <div class="card-content">
                <slot />
              </div>
            </div>
            {#if !$isActive('./charity/ready') && !$isActive('./business/ready')}
            <div class="block mt-3 has-text-centered has-text-grey-light">
              <a href={$url('/start')} class="has-text-grey-light">Restart</a> | <a on:click={signout} class="has-text-grey-light">Sign out</a>
            </div>
            {/if}
          </div>
        </div>
      </div>
    </div>
  </section>
</Secure>

<script lang="ts">
  import Secure from '../_components/Secure.svelte';
  import { url, goto, isActive } from "@sveltech/routify";
  import { appState } from "../../lib/appState";

  async function signout() {
    let firebase = window.firebase;

    await firebase.auth().signOut();
    $appState.user = undefined;
    $appState.charity = undefined;

    $goto('/');
  }
</script>